import { Box, Heading } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';

const NAMES = [
  'estimates',
  'visualizations',
  'privacy protection',
  'collaboration',
];

const Header = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  useEffect(() => {
    const unsub = setInterval(() => {
      setCurrentIndex(prv => (prv + 1 >= NAMES.length ? 0 : prv + 1));
    }, 1000);

    return () => clearInterval(unsub);
  }, []);

  return (
    <Box d="flex" alignItems="center" mb={{ base: 800, tablet: '72px' }}>
      <Heading
        style={{ marginBottom: 0 }}
        size={{ base: 500, tablet: 700 }}
        as="h2"
      >
        Better&nbsp;{NAMES[currentIndex]}
      </Heading>
    </Box>
  );
};

export default Header;
